import React, { createContext, useState, useCallback, useMemo } from 'react'
import { Toast } from '@arvoreeducacao/bonsai-ds'
import type {
  ToastContextProps,
  ToastPostion,
  ToastType,
  showToastProps
} from './ToastContext.types'

const ToastContext = createContext<ToastContextProps>({
  toastMessage: () => null
})

const ToastProvider: React.FC<{ children: React.ReactElement }> = ({
  children
}) => {
  const [toastType, setToastType] = useState<ToastType>('success')
  const [showToast, setShowToast] = useState(false)
  const [message, setMessage] = useState('')
  const [textButton, setTextButton] = useState(undefined)
  const [position, setPosition] = useState<ToastPostion>('bottom-left')
  const [autoClose, setAutoClose] = useState(true)

  const ToastMessage = useCallback(
    ({ type, message, textButton, position, autoClose }: showToastProps) => {
      type ? setToastType(type) : setToastType('success')
      setShowToast(true)
      setMessage(message)
      setTextButton(textButton)
      position ? setPosition(position) : setPosition('bottom-left')
      setAutoClose(autoClose !== undefined ? autoClose : true)
    },
    []
  )

  const handleCloseToast = useCallback(() => {
    setShowToast(false)
  }, [])

  const contextValue = useMemo(
    () => ({
      toastMessage: ToastMessage
    }),
    [ToastMessage]
  )

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <Toast
        type={toastType}
        show={showToast}
        text={message}
        position={position}
        handleClose={handleCloseToast}
        textButton={textButton}
        autoClose={autoClose}
      />
    </ToastContext.Provider>
  )
}

export { ToastProvider, ToastContext }
